<palantir-page>
  <palantir-page-header>
    <ng-content select="[palantir-modal-header], palantir-modal-header" />
  </palantir-page-header>

  <palantir-page-content>
    <ng-content select="[palantir-modal-content], palantir-modal-content" />
  </palantir-page-content>

  <ng-content select="[palantir-modal-bulk-actions], palantir-modal-bulk-actions" />

  <palantir-page-footer>
    <ng-content select="[palantir-modal-footer], palantir-modal-footer" />
  </palantir-page-footer>
</palantir-page>
